import { DatePicker } from "@foris/avocado-suite";
import { useTranslation } from "react-i18next";
import { formatLocalDate, parseLocalDate } from "@utils/days";
import styles from "./sessionDateCell.module.scss";

interface SessionDateCellProps {
  date: string | null;
  disabled: boolean;
  description?: string;
  isDateAllowed: (date: string) => boolean;
  onChange: (date: string) => void;
}

const SessionDateCell = ({
  date,
  disabled,
  description,
  isDateAllowed,
  onChange,
}: SessionDateCellProps) => {
  const { t } = useTranslation();
  const formattedDate = date ? date.split("-").reverse().join("/") : "";
  if (disabled)
    return (
      <div className={styles.readOnly}>
        <span>{formattedDate || "—"}</span>
        {description && <span className={styles.description}>{description}</span>}
      </div>
    );
  return (
    <DatePicker
      key={date ?? "empty"}
      className={styles.datePicker}
      selectedDate={date ? parseLocalDate(date) : null}
      placeholder={t("assignation-edit.session-view.editor.date-placeholder")}
      autoCloseOnSelect
      calendarProps={{
        customInput: (
          <button type="button">
            {formattedDate || t("assignation-edit.session-view.editor.date-placeholder")}
          </button>
        ),
        filterDate: value => isDateAllowed(formatLocalDate(value)),
        "aria-label": `${t("assignation-edit.session-view.table.date")}: ${formattedDate}`,
        portalId: "session-assignation-calendar",
        popperProps: { strategy: "fixed", transform: false },
      }}
      onChange={value => {
        if (value && isDateAllowed(formatLocalDate(value))) onChange(formatLocalDate(value));
      }}
    />
  );
};

export default SessionDateCell;
